module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/5/5-ced4d279bf75054090706a53ee0f346b.jpg";